/**
 * /tenants/$slug/directory/attributes — route shim.
 *
 * Mounts the tenant's own attributes for people. Reading them needs
 * directory.read; the page handles a tenant they do not apply to.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AttributesPage } from "@/features/directory-attributes/pages/attributes-page";

export const Route = createFileRoute("/_authed/tenants/$slug/directory/attributes")({
  component: AttributesPage,
});
